module.exports = __webpack_public_path__ + "static/media/step-challenge-intro.e6a69ea3.png";